<template>
    <footer class="app-footer bg-dark py-3">
      <b-container class="h-100">
        <b-row class="h-100" align-content="center" align-v="center">
          <b-col v-if="$store.getters['auth/role'] !== 'Freelancer'">
            <a @click="$router.push({name: $getConst.routesNames.administration.privacyPolicy})"
               class="text-light mb-3">Privacy Policy</a>
            <a class="text-light mb-3 inactiveLink"> & </a>
            <a @click="$router.push({name: $getConst.routesNames.administration.termsAndConditions})"
               class="text-light mb-3">Terms And Conditions</a>
            <p class="text-light mb-0 mt-2">HAYS © HAYS PLC {{this.currentYear}}</p>
          </b-col>
        </b-row>
      </b-container>
    </footer>
</template>

<script>
  export default {
    name: "AppFooter",
    computed: {
      currentYear() {
        return new Date().getFullYear();
      }
    }
  }
</script>

<style scoped>
    a.text-light{
      cursor: pointer;
}
    .inactiveLink {
      pointer-events: none;
      cursor: default;
    }
</style>
